<div class="gha-contact-popup">
  <div class="gha-contact-popup-header">
    <h1 i18n="@@global.gha-contact">GHA Contact</h1>
    <svg
      (click)="closeModal()"
      style="cursor: pointer"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.174 15.4505C17.4029 15.6794 17.5316 15.99 17.5316 16.3138C17.5316 16.6375 17.4029 16.9481 17.174 17.177C16.945 17.406 16.6345 17.5346 16.3107 17.5346C15.9869 17.5346 15.6764 17.406 15.4474 17.177L8.99922 10.7268L2.54899 17.175C2.32003 17.404 2.0095 17.5326 1.68571 17.5326C1.36191 17.5326 1.05138 17.404 0.822427 17.175C0.59347 16.946 0.464844 16.6355 0.464844 16.3117C0.464844 15.9879 0.59347 15.6774 0.822427 15.4484L7.27266 9.00024L0.824458 2.55C0.595501 2.32105 0.466875 2.01052 0.466875 1.68672C0.466875 1.36293 0.595501 1.0524 0.824458 0.823442C1.05341 0.594486 1.36395 0.465859 1.68774 0.465859C2.01153 0.465859 2.32206 0.594486 2.55102 0.823442L8.99922 7.27368L15.4495 0.822426C15.6784 0.59347 15.9889 0.464844 16.3127 0.464844C16.6365 0.464844 16.9471 0.59347 17.176 0.822426C17.405 1.05138 17.5336 1.36191 17.5336 1.68571C17.5336 2.0095 17.405 2.32003 17.176 2.54899L10.7258 9.00024L17.174 15.4505Z"
        fill="#1F1F1F"
      />
    </svg>
  </div>

  <div class="contact-body">
    <div class="contact-body-address">
      <div class="contact-info">
        <span i18n="@@global.Agent">Agent</span>
        <span
          [matTooltip]="'Copy'"
          matTooltipPosition="below"
          (click)="copyToClipboard(getAgent())"
          >{{ getAgent() }}</span
        >
      </div>
      <div class="contact-info">
        <span i18n="@@gha-contact-popup.address">Address</span>
        <span
          [matTooltip]="'Copy'"
          matTooltipPosition="below"
          (click)="copyToClipboard(getAddress())"
          >{{ getAddress() }}</span
        >
      </div>
    </div>

    <div class="gha-contact-container">
      <div class="contact-body">
        @if (gha.ghaAttachments?.length > 0) {
          <div class="contact-info">
            <span class="file-header" i18n="@@global.Files">Files</span>
            <ul
              class="file-list"
              [ngClass]="{ 'scroll-enabled': gha.ghaAttachments.length > 3 }"
            >
              @for (file of gha.ghaAttachments; track file) {
                <li class="file-item">
                  <div class="file-container">
                    <span
                      class="attachment-icon"
                      (click)="downloadGHADownload(file.id)"
                      [style.background-image]="
                        'url(' + getIconPath(file.fileName) + ')'
                      "
                    ></span>
                    <span
                      (click)="downloadGHADownload(file.id)"
                      class="file-name"
                      >{{ getFileName(file.fileName) }}</span
                    >
                  </div>
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>
  </div>
</div>
